/**
 * Converia.Invoice.ElectronService
 */
Converia.Core.module('Converia.Invoice.ElectronService', function () {
    /**
     * ElectronService
     * 
     * @constructor
     */
    var ElectronService = function () {

    };

    /**
     * ElectronService.prototype.getIPC
     * 
     * @returns {*}
     */
    ElectronService.prototype.getIPC = function () {
        var currentParent = window;
        var indexForParents = 0;

        while (currentParent !== currentParent.parent) {
            currentParent = currentParent.parent;
            indexForParents++;
            
            if (indexForParents > 10) {
                throw new Error("Max iframe recursion depth reached, could not find parent.");
            }
        }
        
        if (typeof currentParent.ipc === 'undefined') {
            throw new Error("IPC Service not found.");
        }
        
        return currentParent.ipc;
    };

    /**
     * ElectronService.prototype.inElectron
     * 
     * @returns {boolean}
     */
    ElectronService.prototype.inElectron = function () {
        var userAgent = navigator.userAgent.toLocaleLowerCase();
        return userAgent.indexOf(' electron/') > -1;
    };

    /**
     * ElectronService.prototype.send
     * 
     * @param eventName
     * @param data
     */
    ElectronService.prototype.send = function (eventName, data) {
        this.getIPC().send(eventName, data);
    };

    /**
     * ElectronService.prototype.removeAllListeners
     * 
     * @param eventName
     */
    ElectronService.prototype.removeAllListeners = function (eventName) {
        this.getIPC().removeAllListeners(eventName);
    };

    /**
     * ElectronService.prototype.once
     * 
     * @param eventName
     * @param callback
     */
    ElectronService.prototype.once = function (eventName, callback) {
        this.getIPC().once(eventName, callback);
    };

    return ElectronService;
});